import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { ETextareaStyleType } from "../../data-types/textarea-style.enum";
import { FormArray, FormControl, Validators } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { EInputMediaStyleType } from "../../data-types/input-media-style.enum";
import { iconsLibrary } from "../../../theme/constants";
import { NgxCSVParserError, NgxCsvParser } from "ngx-csv-parser";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { UserService } from "../../services/user.service";
import { IAppState } from "../../store/state/app.state";
import { CompanyService } from "../../services/company.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";

var window: any;

@Component({
  selector: "cowing-core-company-employees",
  templateUrl: "./company-employees.component.html",
  styleUrls: ["./company-employees.component.scss"],
})
export class CompanyEmployeesComponent implements OnInit, OnDestroy {
  @Input("form") form: FormArray;
  @Output("location") location = new EventEmitter();
  public EInputStyleType = EInputStyleType;

  public EInputMediaStyleType = EInputMediaStyleType;
  public EButtonType = EButtonType;
  public ETextareaStyleType = ETextareaStyleType;
  hasCsvError = false;
  hasCsvErrorHeaders = false;
  hasCsvErrorData = false;
  csvDataChecked = false;
  headersExample = [
    "name",
    "email",
    "total_cowings",
    "language",
    "cp",
    "employee_id",
  ];
  constructor(
    private router: Router,
    private ngxCsvParser: NgxCsvParser,
    private userService: UserService,
    private translate: TranslateService,
    private _store: Store<IAppState>,
    private companyService: CompanyService
  ) {}
  async ngOnInit() {
    this.csvDataChecked = this.form.controls.length > 0 ? true : false;
    // const companyId = LocalStorageService.instance.get(
    //   EStorageType.ActiveCompany
    // );
    // if (companyId && this.isEditingInfo) {
    //   this._store.dispatch(showLoadingAction({}));
    //   const response = await this.companyService.getCompanyInfo(
    //     companyId
    //   );
    //   this.form.patchValue({
    //     is_business_group: response.business_group ? "Si" : "No",
    //   });
    //   this.form.patchValue({ ...response });
    //   this.form.markAllAsTouched();
    //   this._store.dispatch(closeLoadingAction({}));
    // }
    //   "Translate info",
    //   this.translate.instant("company.steps.services")
    // );
    // this.form.get("is_business_group").valueChanges.subscribe((value) => {
    //   const businessGroupName = this.form.get("business_group");
    //   if (value === "No" && businessGroupName.disabled === false) {
    //     businessGroupName.setValidators([]);
    //     businessGroupName.disable();
    //   } else if (value === "Si" && businessGroupName.disabled === true) {
    //     businessGroupName.setValidators([Validators.required]);
    //     businessGroupName.enable();
    //   }
    //   businessGroupName.setValue("");
    //   businessGroupName.updateValueAndValidity();
    // });
  }
  public importCSV($event: any) {
    // Select the files from the event
    const files = $event.srcElement.files;

    // Parse the file you want to select for the operation along with the configuration
    this.ngxCsvParser
      .parse(files[0], { header: false, delimiter: "," })
      .pipe()
      .subscribe(
        async (result: Array<any>) => {
          this.hasCsvErrorHeaders = this.checkErrors(result[0]);
          this.hasCsvErrorData = this.checkData(result);
          this.csvDataChecked = false;
          const [, ...filteredResult] = result;

          if (!this.hasCsvErrorHeaders && !this.hasCsvErrorData) {
            const whereIsEmailField = this.headersExample.indexOf("email");
            const emails = [];
            for (let i = 0; i < filteredResult.length; i++) {
              const email = filteredResult[i][whereIsEmailField];
              emails.push(email);
            }
            // if (!this.isEditingInfo) {
            //   this._store.dispatch(showLoadingAction({}));
            //   try {
            //     await this.userService.usersCheckEmailList(emails);
            //     this.pushEmployeesToForm(filteredResult);
            //   } catch (e) {
            //     this._store.dispatch(
            //       showAlertAction({
            //         payload: {
            //           message: e.error,
            //           title: this.translate.instant("general.caution"),
            //           type: "error",
            //         },
            //       })
            //     );
            //   } finally {
            //     this._store.dispatch(closeLoadingAction({}));
            //   }
            // } else {
            //   this.pushEmployeesToForm(filteredResult);
            // }
            this.pushEmployeesToForm(filteredResult);
          } else {
            if (this.form.value.length > 0) {
              this.form.clear();
            }
          }
        },
        (error: NgxCSVParserError) => {
          if (error.code !== 404) {
            this.csvDataChecked = false;
            this.hasCsvError = true;
          }
        }
      );
  }

  private pushEmployeesToForm(data) {
    if (this.form.controls.length > 0) {
      console.log("???????");
      this.form.clear();
    }
    this.hasCsvError = false;
    this.hasCsvErrorData = false;
    this.hasCsvErrorHeaders = false;
    data.forEach((employee) => {
      const newGroup = new FormGroup({});
      employee.forEach((element, i) => {
        newGroup.addControl(
          this.headersExample[i],
          new FormControl(employee[i])
        );
      });
      this.form.push(newGroup);
    });
    this.csvDataChecked = true;
  }
  private checkErrors(headers) {
    return JSON.stringify(this.headersExample) !== JSON.stringify(headers);
  }
  private checkData(data) {
    const whereIsNonMandatoryField = this.headersExample.indexOf("employee_id");
    const every = data.map((row) => {
      return row.map((elem, i) => {
        if (whereIsNonMandatoryField !== i) {
          return elem && elem.length > 0;
        } else {
          return true;
        }
      });
    });
    const isCorrect = every.every((elem) => {
      return elem.every((e) => e === true);
    });

    return !isCorrect;
  }
  public get isEditingInfo() {
    return this.router.url === "/company-employees" ? true : false;
  }
  public setLocation(currentLocation) {
    !this.isEditingInfo
      ? this.location.emit(currentLocation)
      : this._setLocation(currentLocation);
  }
  public _setLocation(location) {
    this.form.get("latitude").setValue(location.lat);
    this.form.get("longitude").setValue(location.lng);
    this.form.get("city").setValue(location.city);
    this.form.get("country").setValue(location.country);
    this.form.get("province").setValue(location.province);
  }
  public goBack() {
    this.router.navigate(["company-home/employees"]);
  }

  public get getEmployeesSvg() {
    return `${iconsLibrary.employeesSvg}`;
  }

  public get getCircleChecked() {
    return `${iconsLibrary.checkCircle}`;
  }

  public get isDisabledForm() {
    return this.form.value.length > 0 ? false : true;
  }
  ngOnDestroy() {
    // this.form.get("is_business_group").valueChanges.
  }

  public async putEmployees() {
    const companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    this._store.dispatch(showLoadingAction({}));
    try {
      if (this.isEditingInfo) {
        const response = await this.companyService.putEmployeesToCompany(
          this.form.value,
          companyId
        );
      } else {
        const response = await this.companyService.postEmployeesToCompany(
          this.form.value,
          companyId
        );
      }
      this.goBack();
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  downloadFile() {
    //window.open("../../../../../../src/assets/files/COWORKERS.csv");
  }
}
